<template>
  <div class="activity-score-edit">
    <el-dialog title="修改成绩" :visible.sync="scoreEditShow" width="50%" :before-close="dialogClose" @open="dialogOpen">
      <div class="btn-list">
        <!-- 学生姓名：<span style="margin-right: 5px; font-weight: bold">{{
          scoreEditData.studentName
        }}</span> -->
      </div>
      <el-table :data="activityFullList" border style="
          width: 600px;
          margin: 0 auto;
          max-height: 300px;
          overflow-y: auto;
        ">
        <el-table-column label="学生" prop="studentName"> </el-table-column>
        <el-table-column label="实践活动">
          <template slot-scope="scope">
            {{ activityData.activityName }}
          </template>
        </el-table-column>
        <el-table-column label="学时" prop="hours">
          <template slot-scope="scope">
            <el-input v-model="scope.row.hours"></el-input>
          </template> </el-table-column>
        <el-table-column label="学分" prop="credit">
          <template slot-scope="scope">
            <el-input v-model="scope.row.credit"></el-input>
          </template> </el-table-column>
        <el-table-column label="评定等级">
          <template slot-scope="scope">
            <el-input v-model="scope.row.evaluationLevel"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="btn-list">
        <el-button type="primary" @click="activityScoreEditSubmit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["scoreEditShow", "scoreEditData", "activityData"],
  data() {
    return {
      activityFullList: [],
    };
  },
  methods: {
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:scoreEditShow", false);
    },
    dialogOpen() {
      this.activityFullList[0] =  this.scoreEditData;
    },
    activityScoreEditSubmit() {
      let data = {
        id: this.scoreEditData.id,
        evaluationLevel: this.activityFullList[0].evaluationLevel,
        credit: +this.activityFullList[0].credit,
        hours: +this.activityFullList[0].hours,
        activityId: this.activityData.id
      };
      this.$emit("editPracticeRecord", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./activityScoreEdit.scss";
</style>